import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import sk from '../locales/sk.ts'

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { sk },
    current: 'sk',
  },
  icons: {
    iconfont: 'mdi',
  },
});
